// Session utility functions to avoid circular imports
import { setUser, setToken, setRefreshToken, setApiKey, setRoles, setModules, setPermissions, setTenantId, setTenantStatus, setIsDemo, resetUserState } from "@/src/store/userSlice";

let storeInstance: any = null;

export const setStore = (store: any) => {
  storeInstance = store;
};
const safeDispatch = (action: any) => {
  if (storeInstance) {
    
    storeInstance.dispatch(action);
  } else {
    console.log(" Store not available - dispatch skipped");
  }
};
export const sessionUtils = {
  
  setUserId: (userId: string) => {
    // Assuming user is set separately, but for now, not dispatching here
  },
  getUserId: () => {
    return storeInstance ? storeInstance.getState().user.user?.id : null;
  },
  setToken: (token: string) => {
    if (storeInstance) storeInstance.dispatch(setToken(token));
  },
  getToken: () => {
    return storeInstance ? storeInstance.getState().user.token : null;
  },
  setRefreshToken: (refreshToken: string) => {
    if (storeInstance) storeInstance.dispatch(setRefreshToken(refreshToken));
  },
  getRefreshToken: () => {
    return storeInstance ? storeInstance.getState().user.refreshToken : null;
  },
  setApiKey: (apiKey: string) => {
    
    if (storeInstance) storeInstance.dispatch(setApiKey(apiKey));
    
  },
  getApiKey: () => {
    const apiKey = storeInstance ? storeInstance.getState().user.apiKey : null;
  
    return apiKey;
  },
  setRoles: (roles: string[]) => {
    if (storeInstance) storeInstance.dispatch(setRoles(roles));
  },
  getRoles: () => {
    return storeInstance ? storeInstance.getState().user.roles : [];
  },
  setModules: (modules: string[]) => {
    if (storeInstance) storeInstance.dispatch(setModules(modules));
  },
  getModules: () => {
    return storeInstance ? storeInstance.getState().user.modules : [];
  },
  setPermissions: (permissions: string[]) => {
    if (storeInstance) storeInstance.dispatch(setPermissions(permissions));
  },
  getPermissions: () => {
    return storeInstance ? storeInstance.getState().user.permissions : [];
  },
  setTenantId: (tenantId: string) => {
    if (storeInstance) storeInstance.dispatch(setTenantId(tenantId));
  },
  getTenantId: () => {
    return storeInstance ? storeInstance.getState().user.tenantId : null;
  },

  setIsDemo: (isDemo: boolean) => {
    if (storeInstance) storeInstance.dispatch(setIsDemo(isDemo));
  },
  getIsDemo: () => {
    return storeInstance ? storeInstance.getState().user.isDemo : false;
  },

  // Tenant inactive status
  setTenantStatus: (status: any) => {
    if (storeInstance) storeInstance.dispatch(setTenantStatus(status ?? null));
  },
  getTenantStatus: () => {
    return storeInstance ? storeInstance.getState().user.tenantStatus : null;
  },

  clearSession: () => {
    if (storeInstance) {
      // Purge persisted state FIRST
      const persistor = (storeInstance as any).__persistor;
      if (persistor) {
        persistor.purge(); // Clears persisted user data
      }
      
      // Then reset state
      storeInstance.dispatch(resetUserState());
    }
    
    // Clear all storage
    // localStorage.clear();
    sessionStorage.clear();
  },
  isAuthenticated: () => {
    return storeInstance ? storeInstance.getState().user.isAuthenticated : false;
  },
};
